import {Injectable, OnDestroy} from '@angular/core';
import {ExamFormModel} from '../../api/model/exam-form.model';
import {ExamFormRepository} from './ngrx/examForm.repository';
import {
    AbstractFindManyPaginatedService
} from '../../../core/service/v2/service/findmany/abstractFindManyPaginated.service';
import {ExamFormDataServiceAdapter} from './ngrx/examFormDataService.adapter';

@Injectable()
export class ExamFormPaginatedService extends AbstractFindManyPaginatedService<ExamFormModel, ExamFormModel>
    implements OnDestroy{

    constructor(repository: ExamFormRepository, dataServiceAdapter: ExamFormDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }

    resolveSortKeyLabel(value: string): string {
        switch (value) {
            case 'date':
                return 'Date';
            case 'createdAt':
                return 'Date de création';
            case 'partner.name':
                return 'Nom du patient';
            case 'status':
                return 'Statut';
        }
        return value;
    }

    ngOnDestroy(): void {
        super.onDestroy();
    }
}
